module.exports = __webpack_public_path__ + "img/rosa_rossa.55202a6e.webp";